export default __webpack_public_path__ + "static/media/muffins-image.97cc1976.png";